// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609020104/js/" + chunkId + "." + {"44":"747707ba","225":"d4f2620d","481":"342bafb1","486":"7c19bb09","770":"adef1021"}[chunkId] + ".0.45494904422444715.chunk.js";
};